
export default {
  data: () => ({
    isCalendlyActive: false,
    itemsListCheckRed: [
      {
        title: "Votre fiche existe, mais elle ne travaille pas pour vous",
        text: "",
      },
      {
        title: "Vos avis clients ne sont ni valorisés ni exploités",
        text: "",
      },
      {
        title: "Votre positionnement local est incertain",
        text: "",
      },
      {
        title:
          "Vous manquez de visibilité face à des concurrents mieux optimisés",
        text: "",
      },
    ],

    argumentsVisibility: [
      {
        img: "fleuriste-gmb.jpg",
        title: "Une fiche Google optimisée",
        text: "Optimisez votre fiche d’établissement pour améliorer votre score de qualité et votre visibilité sur Google Search et Maps.",
      },
      {
        img: "garagiste-gmb.jpg",
        title: "Une gestion active de votre e-réputation",
        text: "Centralisez vos avis clients, facilitez leur collecte et suivez leur évolution pour renforcer votre crédibilité et votre capital confiance.",
      },
      {
        img: "visibility-3.jpg",
        title: "Un pilotage clair de vos performances locales",
        text: "Suivez votre positionnement sur les mots-clés stratégiques, analysez vos concurrents et identifiez les actions prioritaires à mener pour générer plus d’interactions et de contacts.",
      },
    ],

    price: {
      price: 49,
      text: "Une plateforme claire, simple et complète",
    },

    reviews: [
      {
        text: "Merci beaucoup à toute l'équipe qui m'accompagne avec professionnalisme à passer à une autre étape de ma communication.",
        author: "Elise haas",
      },
      {
        text: "Super agence en communication ! Création d'une page web qui correspond à ma demande et un conseiller au top. Merci ALEO !",
        author: "K.B HOME-SERVICES",
      },
      {
        text: "Je suis content de leurs services. Toujours à l'écoute et prêts à nous aider. Merci à toute l'équipe.",
        author: "Y Toitures",
      },
      {
        text: "Le travail réalisé pour le référencement est très sérieux, les équipes sont professionnelles et l'agence fait preuve d'une grande rigueur. Je recommande chaleureusement.",
        author: "Agence Alsacienne de l'Or et Numismatique",
      },
    ],

    timeline: {
      surtitle: "Gérez votre fiche Google simplement",
      title: `La gestion de votre fiche d'établissement <span class="font-clash font-bold">centralisée</span>`,
      steps: [
        {
          img: "seo-step-1.png",
          title: "Prise de contact",
          text: "Rencontrez un conseiller ALEO pour découvrir la plateforme.",
          alt: "Analyse de votre fiche Google",
        },
        {
          img: "web-step-2.png",
          title: "Configuration de votre fiche",
          text: "Nous créons et configurons votre établissement sur Local Pro, prêt à être optimisé.",
          alt: "Optimisation de votre fiche",
        },
        {
          img: "web-step-3.png",
          title: "Optimisation complète",
          text: "Nous mettons à jour vos informations, services, photos et horaires et nous configurons le suivi de vos appels depuis votre fiche.",
          alt: "Actions de développement de la notoriété",
        },
        {
          img: "web-step-4.png",
          title: "Formation à la plateforme",
          text: "Prenez facilement en main l’outil grâce à une présentation guidée et des tutoriels vidéo.",
          alt: "Présentation de la plateforme",
        },
        {
          img: "web-step-5.png",
          title: "Suivi et pilotage",
          text: "Suivez vos performances, analysez vos concurrents et recevez des recommandations pour améliorer votre visibilité locale.",
          alt: "Suivi des performances",
        },
      ],
    },
  }),

  head() {
    return {
      title:
        "Votre outil de gestion de fiche Google - Gérez votre fiche pour 79€/HT par mois | ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Optimisez votre fiche Google avec Local Pro. Gérez vos avis, suivez vos performances et boostez votre visibilité locale sur Google pour attirer plus de clients !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Votre outil de gestion de fiche Google - Gérez votre fiche pour 79€/HT par mois | ALEO",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Optimisez votre fiche Google avec Local Pro. Gérez vos avis, suivez vos performances et boostez votre visibilité locale sur Google pour attirer plus de clients !",
        },
      ],
    };
  },

  methods: {
    activeCalendly() {
      this.isCalendlyActive = false;
      this.$nextTick(() => {
        this.isCalendlyActive = true;
      });
    },
  },
};
